import Head from 'next/head';
import { useSelector } from 'react-redux';
import { NextSeo } from 'next-seo';
import ProdigyContainer from '@cont/Prodigy/ProdigyContainer';
import { fetchTestSeriesData } from '@actions/quizzes';

const TestSeries = () => {
  const data = useSelector(({ quizzes }) => quizzes.testSeries?.prodigy ?? {});
  const { metaData } = data;
  const { title, description, ogImage, twitterOgImage } = metaData;

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          title,
          description,
          images: [
            {
              url: ogImage,
              width: 800,
              height: 600
            }
          ]
        }}
        twitter={{
          images: [
            {
              url: twitterOgImage,
              width: 800,
              height: 600
            }
          ]
        }}
      />
      <Head>
        <title>{metaData.title}</title>
      </Head>
      <ProdigyContainer data={data} />
    </>
  );
};

TestSeries.getInitialProps = async ({ store }) => {
  if (!store.getState().quizzes.testSeries?.prodigy) {
    await store.dispatch(fetchTestSeriesData('prodigy'));
  }
};

TestSeries.pageInfo = {
  name: 'Unacademy Prodigy',
  layoutOptions: {
    hideSearch: true,
    hideGoalSelector: true,
    hideLearnerMinutes: true,
    hideNudges: true,
    disableDarkMode: true,
    useFreeLayout: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default TestSeries;
